function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var LeagueEditorTemplate = require('./editor.template');
var LeagueEditor = /*#__PURE__*/function () {
  function LeagueEditor(app, mod) {
    var league_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, LeagueEditor);
    this.app = app;
    this.mod = mod;
    this.league = this.mod.returnLeague(league_id);
    this.overlay = new SaitoOverlay(app, mod, false, true);
  }
  return _createClass(LeagueEditor, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var pw, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.league == null)) {
                _context.n = 1;
                break;
              }
              salert("League not found");
              return _context.a(2);
            case 1:
              if (!this.league.admin) {
                _context.n = 4;
                break;
              }
              _t = this.league.admin;
              _context.n = 2;
              return this.app.wallet.getPublicKey();
            case 2:
              _t2 = _context.v;
              if (!(_t !== _t2)) {
                _context.n = 3;
                break;
              }
              salert('Unauthorized access!');
              return _context.a(2);
            case 3:
              _context.n = 6;
              break;
            case 4:
              _context.n = 5;
              return sprompt('Enter Password');
            case 5:
              pw = _context.v;
              if (!(this.app.crypto.hash(pw) !== 'e7f69c3b4e30697e68ac57b83088f41ec47de914ad84def95c4f4b25516c39ef')) {
                _context.n = 6;
                break;
              }
              salert('Unauthorized access!');
              return _context.a(2);
            case 6:
              this.overlay.show(LeagueEditorTemplate(this.app, this.mod, this.league), function () {
                _this.submitChanges();
              });
              this.attachEvents();
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (document.querySelector('.league-edit-overlay-box .submit_btn')) {
        document.querySelector('.league-edit-overlay-box .submit_btn').onclick = function () {
          _this2.submitChanges();
          _this2.overlay.remove();
        };
      }
    }
  }, {
    key: "submitChanges",
    value: function () {
      var _submitChanges = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var welcome, newtx, contact, _newtx, description, _newtx2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              welcome = document.querySelector('.league-edit-overlay-box .welcome');
              if (!welcome) {
                _context2.n = 2;
                break;
              }
              if (!(welcome.textContent !== this.league.welcome)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.mod.createUpdateTransaction(this.league.id, welcome.textContent, 'welcome');
            case 1:
              newtx = _context2.v;
              this.app.network.propagateTransaction(newtx);
              this.league.welcome = welcome.textContent;
            case 2:
              contact = document.querySelector('.league-edit-overlay-box .contact');
              if (!contact) {
                _context2.n = 4;
                break;
              }
              if (!(contact.textContent !== this.league.contact)) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return this.mod.createUpdateTransaction(this.league.id, sanitize(contact.textContent), 'contact');
            case 3:
              _newtx = _context2.v;
              this.app.network.propagateTransaction(_newtx);
              this.league.contact = sanitize(contact.textContent);
            case 4:
              description = document.querySelector('.league-edit-overlay-box .description');
              if (!description) {
                _context2.n = 6;
                break;
              }
              if (!(description.textContent !== this.league.description)) {
                _context2.n = 6;
                break;
              }
              _context2.n = 5;
              return this.mod.createUpdateTransaction(this.league.id, description.textContent, 'description');
            case 5:
              _newtx2 = _context2.v;
              this.app.network.propagateTransaction(_newtx2);
              this.league.description = description.textContent;
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function submitChanges() {
        return _submitChanges.apply(this, arguments);
      }
      return submitChanges;
    }()
  }]);
}();
module.exports = LeagueEditor;